export default documento => {
  const docString = documento.toString();
  let cont = 1;
  const primerNum = docString.substr(0, 1);

  if (docString.length <= 0 || !docString) {
    return false;
  }

  if (isNaN(documento)) {
    return false;
  }

  if (docString.length < 7) {
    return false;
  }

  for (let i = 0; i < docString.length; i += 1) {
    if (docString[i + 1] !== undefined) {
      if (primerNum === docString[i + 1]) {
        cont += 1;
      }
    }
  }

  if (cont === docString.length) {
    return false;
  }

  return true;
};



// WEBPACK FOOTER //
// ./src/utils/validarDocumento.js